import React, { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import NavigationBar from "components/molecules/NavigationBar";
import Footer from "components/molecules/Footer";
import paths from "routes/paths";

import { StyledMain, StyledHeader, StyledFooter } from "./styles";

const FreeTestLayout: FC = ({ children }) => {
  const { t } = useTranslation();

  const footer = [{ to: "https://careerfit.com/", title: "CareerFit.com" }];

  return (
    <>
      <StyledHeader>
        <NavigationBar isFreeTest />
      </StyledHeader>
      <StyledMain>{children}</StyledMain>
      <StyledFooter>
        <Footer footerItems={footer} />
      </StyledFooter>
    </>
  );
};

export default FreeTestLayout;
